var _defs, _rect, _path, _path2, _rect2, _rect3, _path3, _rect4, _line, _line2, _line3, _line4, _path4, _circle, _line5, _rect5, _path5, _path6, _path7, _circle2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCpBusinessCardIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 140,
    height: 140,
    viewBox: "0 0 140 140",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.f,.k{fill:none;}.b{fill:#e5e5e5;}.b,.f,.g,.h,.i,.k{stroke:#3c3c46;stroke-linecap:round;stroke-linejoin:round;stroke-width:2px;}.b,.e,.g,.i,.j,.k{fill-rule:evenodd;}.c,.l{fill:#3c3c46;}.c{opacity:0.15;}.d,.i,.j{fill:#fff;}.e{fill:#ffefe0;}.g{fill:#3ca4ef;}.h{fill:#89d9fb;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "CP-business-card-icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 140,
    height: 140
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M68.38,76.35v4.9h.06a5.55,5.55,0,0,0,11,0h0v-4.9Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M79.43,76.35l0,2.45h.06a5.54,5.54,0,0,0,11,0h0l-1.2-2.45Z"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 23.28,
    y: 39.17,
    width: 71.64,
    height: 43.17,
    rx: 4.05,
    ry: 4.05
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "d",
    x: 17.28,
    y: 33.17,
    width: 77.71,
    height: 43.17,
    rx: 4.05,
    ry: 4.05
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M56.14,33.17H91.35A3.66,3.66,0,0,1,95,36.82V72.7a3.66,3.66,0,0,1-3.64,3.64H56.14Z"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "f",
    x: 17.28,
    y: 33.17,
    width: 77.71,
    height: 43.17,
    rx: 4.05,
    ry: 4.05
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "f",
    x1: 52.59,
    y1: 43.33,
    x2: 84.05,
    y2: 43.33
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "f",
    x1: 52.59,
    y1: 49.74,
    x2: 84.05,
    y2: 49.74
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "f",
    x1: 52.59,
    y1: 56.14,
    x2: 84.05,
    y2: 56.14
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "f",
    x1: 52.59,
    y1: 62.54,
    x2: 76.74,
    y2: 62.54
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M34.27,61.74H26.69a7.58,7.58,0,1,1,15.15,0Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "h",
    cx: 34.27,
    cy: 46.11,
    r: 4.93
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "f",
    x1: 26.69,
    y1: 67.14,
    x2: 41.85,
    y2: 67.14
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 68.38,
    y: 64.31,
    width: 16.71,
    height: 12.04
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M105.9,43.61H95L94.8,70.55,76,59.81l0,.06a5.54,5.54,0,0,0-5.49,9.51l0,.07L88.2,81.3l1.4,7a9.12,9.12,0,0,0,9,7.56l.81,2.91,20.39,1.93-4.36-48.4A9.61,9.61,0,0,0,105.9,43.61Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M88.29,106.83V97.35a1.53,1.53,0,0,1,1.53-1.53h31.38a1.53,1.53,0,0,1,1.53,1.53v9.48Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M88.29,106.83V97.35a1.53,1.53,0,0,1,1.53-1.53h31.38a1.53,1.53,0,0,1,1.53,1.53v9.48"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "l",
    cx: 94.54,
    cy: 102.51,
    r: 2.11
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCpBusinessCardIcon);
export default __webpack_public_path__ + "static/media/CP-business-card-icon.edea60b3c40988ec43f9c45e55997409.svg";
export { ForwardRef as ReactComponent };